import { Record, List } from 'immutable';
import { DesignItems } from 'records/DesignItem';

const defaultValues = {
  id: null,
  designPageId: null,
  designId: null,
  userCategoryId: null,
  menutype:'',
  name: '',
  description: '',
  designItems: DesignItems(),
  ordinal: 0,
  archived: false,
  createdBy: null,
  created: null,
  updatedBy: null,
  updated: null,
  loadToCanvas: false,
};

export default class DesignSection extends Record(defaultValues, DesignSection) {
  constructor(values) {
    super({
      ...values,
      designItems: values && values.designItems
          ? DesignItems(values.designItems)
          : defaultValues.designItems,
    });
  }

  static deleteDesignSectionByIndex(designSections, index) {
    return designSections.delete(index);
  }

  static insertDesignSectionByIndex(designSections, index, designSection) {
    return designSections.insert(index, designSection);
  }

  static getDesignSectionById(designSections, id) {
    return designSections.find((designSection) => {
      return designSection.get('id') === id ? designSection : undefined;
    });
  }

  static sortDesignSectionsByOrdinal(designSections) {
    return designSections.sort((itemOne, itemTwo) => {
      if (itemOne.get('ordinal') < itemTwo.get('ordinal')) return -1;
      if (itemOne.get('ordinal') > itemTwo.get('ordinal')) return 1;
      return 0;
    });
  }

  static updateDesignSectionsOrdinalsFromIndex(designSections) {
    return designSections.map((item, index) => {
      return item.set('ordinal', index);
    });
  }
}

export const DesignSections = (data) => {
  let designSections = new List();
  if (data) {
    data.forEach((value) => {
      designSections = designSections.push(new DesignSection(value));
    });
  }
  return designSections;
};
